import { useQuery } from "react-query";
import { accountsRequest } from "./accounts";
import { QueryParams } from "../../types/base";
import { queryKeys } from "../../query";
import { AccountListResponseData } from "../../types/account";

const fetchAccounts = async (
  params: QueryParams,
): Promise<AccountListResponseData> => {
  return accountsRequest(params);
};

export const useAccountList = (
  params: QueryParams,
  options?: { enabled?: boolean },
) => {
  const enabled = options?.enabled ?? true;
  return useQuery(
    queryKeys.accountListPage(params),
    () => fetchAccounts(params),
    { enabled },
  );
};
